(function () {
  'use strict';

  var scriptUrl = document.currentScript && document.currentScript.src ? document.currentScript.src : '';
  var assetBase = scriptUrl.slice(0, scriptUrl.lastIndexOf('/') + 1);

  var iconPaths = {
    sole: '<path d="M2.5 9.5 7 10.7v4.1h2.8c2.5 0 4.5-1.5 6.7-1.7 1.8-.2 3.3-.7 5-1.7v3.1c-3 1.9-6.4 2.9-10.1 3.2H7v1.8H3.2L2.5 9.5Z"/><path d="M7 14.8c2.8.2 4.5.1 6.3-.6 2.7-1 5.4-.8 8.2-2.8"/>',
    vamp: '<path d="M3 7.1c.3 2.6-.1 5.3-1 7.9 3.7 2.6 8 3.8 12.9 3.5 2.5-.1 4.7-.8 6.6-2v-2.7c-1.1-.7-2.4-1-3.9-1.1-4.2-.2-7.4-1.3-9.8-3.2L5.2 7.4"/><path d="M2.8 14.2c5.6 1.8 11.8 2.3 18.7.4"/>',
    stitch: '<path d="M9 3h6v9.8c0 1.4.7 2.5 2 3.7L12 21l-5-4.5c1.3-1.2 2-2.3 2-3.7V3Z"/><path d="M10.6 4.2v8.9c0 1.7-.7 2.7-1.4 3.3L12 19l2.8-2.6c-.7-.6-1.4-1.6-1.4-3.3V4.2" stroke-dasharray="1.2 1.7"/>',
    pulls: '<path d="M9 3h6v9.8c0 1.5.7 2.7 2.1 3.8L12 21l-5.1-4.4C8.3 15.5 9 14.3 9 12.8V3Z"/>',
    shaft: '<path d="M5.5 20.5c1.2-.9 1.8-2.2 1.8-4V6.2C8.2 4.6 9.7 3.8 12 3.8s3.8.8 4.7 2.4v10.3c0 1.8.6 3.1 1.8 4"/><path d="M7.3 6.2C9.9 5.3 14.1 5.3 16.7 6.2"/><path d="M10.4 4v7.4c0 1.2-.5 2.1-1.2 2.8L12 17l2.8-2.8c-.7-.7-1.2-1.6-1.2-2.8V4"/>',
    trim: '<path d="M3 16.8c2.7-3.1 6.2-4.6 10.5-4.4 3.3.1 5.7-.5 7.5-2"/><path d="M4.1 18.1c2.6-2.5 5.7-3.6 9.4-3.5 3.4.1 6-.6 7.5-1.7"/>',
    embroidery: '<path d="M11.8 20v-7.2M12.2 12.8V20"/><path d="M11.8 16.5 8.2 14l-3.5.8 2.1-2.7-2.1-2.6 3.5.7 3.6-2.5M12.2 16.5l3.6-2.5 3.5.8-2.1-2.7 2.1-2.6-3.5.7-3.6-2.5"/><path d="M8.5 6.5 12 3l3.5 3.5L12 8.8 8.5 6.5Z"/>',
    size: '<path d="M5 6h14v12H5z"/><path d="M8 6v4m3-4v2m3-2v4m3-4v2"/>'
  };

  var iconFiles = {
    stitch: 'vv-icon-pespunte-v2.svg',
    trim: 'vv-icon-ribete-v2.svg',
    ringle: 'vv-icon-ringle-v2.svg'
  };

  function normalizeLabel(label) {
    return label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function isReeditMode() {
    return /(?:^|[?&])modifyProduct=/.test(window.location.search);
  }

  function urlParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function categoryKey(label) {
    var normalized = normalizeLabel(label).trim();
    if (normalized.indexOf('pespunte') > -1) return 'pespunte';
    return normalized;
  }

  function iconKey(label) {
    var name = normalizeLabel(label);
    if (name.indexOf('suela') > -1) return 'sole';
    if (name.indexOf('chinela') > -1) return 'vamp';
    if (name.indexOf('pespunte') > -1 || name.indexOf('costura') > -1 || name.indexOf('hilo') > -1) return 'stitch';
    if (name.indexOf('oreja') > -1 || name.indexOf('jaladera') > -1) return 'pulls';
    if (name.indexOf('tubo') > -1) return 'shaft';
    if (name.indexOf('ringle') > -1) return 'ringle';
    if (name.indexOf('ribete') > -1 || name.indexOf('borde') > -1) return 'trim';
    if (name.indexOf('bordado') > -1) return 'embroidery';
    if (name.indexOf('talla') > -1 || name.indexOf('size') > -1) return 'size';
    return 'stitch';
  }

  function icon(label) {
    var key = iconKey(label);
    if (key === 'size') {
      return '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round">' + iconPaths[key] + '</svg>';
    }
    return '<img aria-hidden="true" src="' + assetBase + (iconFiles[key] || ('vv-icon-' + key + '.png')) + '" alt="" width="48" height="48">';
  }

  function productVariants() {
    var data = document.getElementById('vv-cpb-product-variants');
    if (!data) return null;
    try {
      var parsed = JSON.parse(data.textContent);
      parsed.variants = (parsed.variants || []).filter(function (variant) { return variant.available; });
      return parsed.variants.length > 1 ? parsed : null;
    } catch (error) {
      return null;
    }
  }

  function addSizeProperty(body) {
    if (!window.vvCpbSelectedSize || !body) return body;
    if (body instanceof FormData) {
      body.set('properties[Talla]', window.vvCpbSelectedSize);
      return body;
    }
    if (body instanceof URLSearchParams) {
      body.set('properties[Talla]', window.vvCpbSelectedSize);
      return body;
    }
    if (typeof body === 'string') {
      try {
        var json = JSON.parse(body);
        if (json.items) {
          json.items.forEach(function (item) {
            item.properties = item.properties || {};
            item.properties.Talla = window.vvCpbSelectedSize;
          });
        } else {
          json.properties = json.properties || {};
          json.properties.Talla = window.vvCpbSelectedSize;
        }
        return JSON.stringify(json);
      } catch (error) {
        return body + (body ? '&' : '') + 'properties%5BTalla%5D=' + encodeURIComponent(window.vvCpbSelectedSize);
      }
    }
    return body;
  }

  function installCartProperty() {
    if (window.vvCpbCartPropertyReady) return;
    window.vvCpbCartPropertyReady = true;

    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : input && input.url;
        if (url && /\/cart\/add(?:\.js)?(?:\?|$)/.test(url) && init && init.body) {
          init = Object.assign({}, init, { body: addSizeProperty(init.body) });
        }
        return nativeFetch.call(this, input, init);
      };
    }

    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.vvCpbUrl = url;
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (this.vvCpbUrl && /\/cart\/add(?:\.js)?(?:\?|$)/.test(this.vvCpbUrl)) body = addSizeProperty(body);
      return nativeSend.call(this, body);
    };
  }

  function labelFor(category) {
    var label = category.querySelector('.cpb-category-title span, .cpb-category-title');
    return label ? label.textContent.trim() : 'Detalle';
  }

  function displayLabel(label) {
    return normalizeLabel(label).indexOf('pespunte') > -1 ? 'Pespunte' : label;
  }

  function valueFor(category) {
    var value = category.querySelector('[class*="singleValue"], .cpb-active .cpb-option-title, .cpb-active .cpb-option-label');
    if (!value) return '';
    var cleanValue = value.cloneNode(true);
    Array.prototype.forEach.call(cleanValue.querySelectorAll('.option-label-price, [data-testid="multycurrency-price"]'), function (price) { price.remove(); });
    return cleanValue.textContent.replace(/\{\{[^}]+\}\}/g, '').trim();
  }

  function categoryHasNoOptions(category) {
    return /(?:^|\s)(?:no options|sin opciones)(?:\s|$)/i.test(category.textContent || '');
  }

  function cleanTemplateTokens(scope) {
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var clean = node.nodeValue.replace(/\s*\{\{compareAtPrice\}\}/g, '');
      if (clean !== node.nodeValue) node.nodeValue = clean;
    }
  }

  function currentPrice() {
    var price = root.querySelector('.cpb-product-price');
    if (!price) return '';
    var cleanPrice = price.cloneNode(true);
    return cleanPrice.textContent.replace(/\{\{[^}]+\}\}/g, '').replace(/\s+/g, ' ').trim();
  }

  function setup(panel) {
    if (panel.dataset.vvWizardReady === 'true') return panel.vvApi;

    var categoryContainer = panel.querySelector('.cpb-panel-categories-container');
    var categories = Array.prototype.slice.call(panel.querySelectorAll(':scope > .cpb-panel-wrapper > .cpb-panel-categories-container > .cpb-category'));
    var sizeData = productVariants();
    if (!categoryContainer || categories.length < 2) return;

    panel.dataset.vvWizardReady = 'true';
    panel.classList.add('vv-wizard-ready', 'vv-wizard-overview');

    var shell = document.createElement('section');
    shell.className = 'vv-wizard';
    shell.setAttribute('aria-label', 'Pasos de personalización');
    shell.innerHTML =
      '<div class="vv-wizard-overview-screen">' +
        '<div class="vv-wizard-heading"><div><p>Tu diseño</p><h2>Elige una parte de la bota</h2></div><span class="vv-wizard-count"></span></div>' +
        '<div class="vv-wizard-grid"></div>' +
        '<div class="vv-wizard-total"><span>Precio total</span><strong></strong></div>' +
        '<button class="vv-wizard-cart" type="button" disabled>Agregar al carrito</button>' +
        '<a class="vv-wizard-terms" href="https://vaquerovaquera.com/pages/terminos-condiciones-y-politicas-custom-shop" target="_blank" rel="noopener">Términos y condiciones del Custom Shop</a>' +
      '</div>' +
      '<div class="vv-wizard-detail-screen" hidden>' +
        '<button class="vv-wizard-back" type="button" aria-label="Volver a todas las partes"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="m15 18-6-6 6-6"/></svg> Todas las partes</button>' +
        '<div class="vv-wizard-step-heading"><span class="vv-wizard-step-number"></span><div><p>Personaliza</p><h2 class="vv-wizard-step-title"></h2></div></div>' +
        '<div class="vv-wizard-slot"></div><div class="vv-wizard-size-options" hidden></div><p class="vv-wizard-size-error" role="alert" hidden>Selecciona una talla para continuar.</p>' +
        '<div class="vv-wizard-nav"><button class="vv-wizard-prev" type="button"><svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m15 18-6-6 6-6"/></svg> Anterior</button><button class="vv-wizard-summary" type="button">Ver resumen</button><button class="vv-wizard-next" type="button">Siguiente <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></button></div>' +
      '</div>';

    categoryContainer.parentNode.insertBefore(shell, categoryContainer);
    var grid = shell.querySelector('.vv-wizard-grid');
    var slot = shell.querySelector('.vv-wizard-slot');
    var sizeOptions = shell.querySelector('.vv-wizard-size-options');
    var nav = shell.querySelector('.vv-wizard-nav');
    categoryContainer.parentNode.insertBefore(nav, categoryContainer.nextSibling);
    nav.hidden = true;
    var activeIndex = -1;
    var selectedSize = '';
    var reeditMode = isReeditMode();
    var totalSteps = categories.length + (sizeData ? 1 : 0);
    var configuredTotal = totalSteps;
    var lastValues = categories.map(valueFor);
    var touchedCategories = categories.map(function (category) { return reeditMode && Boolean(valueFor(category)); });
    var unavailableCategories = {};
    var exoticDependencies = {};

    function materialIsExotic(depKey) {
      return categories.some(function (category, index) {
        var key = categoryKey(labelFor(category));
        if (key !== depKey || !touchedCategories[index]) return false;
        var material = valueFor(category).replace(/^\s+|\s+$/g, '');
        return Boolean(material) && !/^res(?:\s|$)/i.test(material);
      });
    }

    function activeCategoryHasNoOptions() {
      if (activeIndex < 0 || activeIndex >= categories.length) return false;
      var activeCategory = categories[activeIndex];
      if (categoryHasNoOptions(activeCategory)) return true;
      return Array.prototype.some.call(
        activeCategory.querySelectorAll('[role="listbox"], [class*="-menu"], [class*="-menu-list"]'),
        function (menu) {
          return /(?:^|\s)(?:no options|sin opciones)(?:\s|$)/i.test(menu.textContent || '');
        }
      );
    }

    function syncTotalPrice() {
      var target = shell.querySelector('.vv-wizard-total strong');
      var price = currentPrice();
      if (target.textContent !== price) target.textContent = price;
    }

    categories.forEach(function (category, index) {
      category.dataset.vvStep = index;
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'vv-wizard-card';
      card.dataset.step = index;
      card.innerHTML = '<span class="vv-wizard-card-icon">' + icon(labelFor(category)) + '</span><span class="vv-wizard-card-copy"><strong>' + displayLabel(labelFor(category)) + '</strong><small>No has elegido</small></span><span class="vv-wizard-card-state" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></span>';
      grid.appendChild(card);
    });

    if (sizeData) {
      var sizeCard = document.createElement('button');
      sizeCard.type = 'button';
      sizeCard.className = 'vv-wizard-card vv-wizard-size-card';
      sizeCard.dataset.step = categories.length;
      sizeCard.innerHTML = '<span class="vv-wizard-card-icon">' + icon('Talla') + '</span><span class="vv-wizard-card-copy"><strong>' + (sizeData.optionName || 'Talla') + '</strong><small>Elegir talla</small></span><span class="vv-wizard-card-state" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></span>';
      grid.appendChild(sizeCard);
      sizeData.variants.forEach(function (variant) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'vv-wizard-size-button';
        button.dataset.variantId = variant.id;
        button.dataset.size = variant.title;
        button.textContent = variant.title;
        sizeOptions.appendChild(button);
      });
      if (reeditMode) {
        var preselectVariantId = urlParam('variant');
        var preselectVariant = preselectVariantId && sizeData.variants.filter(function (variant) {
          return String(variant.id) === String(preselectVariantId);
        })[0];
        if (preselectVariant) {
          selectedSize = preselectVariant.title;
          window.vvCpbSelectedSize = selectedSize;
          window.vvCpbSelectedVariantId = preselectVariant.id;
          var preselectButton = sizeOptions.querySelector('[data-variant-id="' + preselectVariant.id + '"]');
          if (preselectButton) {
            preselectButton.classList.add('is-selected');
            preselectButton.setAttribute('aria-pressed', 'true');
          }
        }
      }
    }

    function addDynamicCategory(category) {
      if (categories.indexOf(category) > -1 || labelFor(category) === 'Detalle') return;
      var normalizedLabel = categoryKey(labelFor(category));
      var pendingCard = grid.querySelector('.vv-wizard-card.is-pending-category[data-category-label="' + normalizedLabel + '"]');
      if (pendingCard) pendingCard.remove();
      var existingIndex = categories.findIndex(function (existingCategory) {
        return categoryKey(labelFor(existingCategory)) === normalizedLabel;
      });
      if (existingIndex > -1) {
        categories[existingIndex] = category;
        category.dataset.vvStep = existingIndex;
        lastValues[existingIndex] = valueFor(category);
        if (observer) observer.observe(category, { childList: true, subtree: true, characterData: true });
        update();
        return;
      }
      var index = categories.length;
      categories.push(category);
      touchedCategories.push(reeditMode && Boolean(valueFor(category)));
      lastValues.push(valueFor(category));
      category.dataset.vvStep = index;

      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'vv-wizard-card';
      card.dataset.step = index;
      card.innerHTML = '<span class="vv-wizard-card-icon">' + icon(labelFor(category)) + '</span><span class="vv-wizard-card-copy"><strong>' + displayLabel(labelFor(category)) + '</strong><small>No has elegido</small></span><span class="vv-wizard-card-state" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></span>';
      grid.insertBefore(card, sizeCard || null);

      if (sizeCard) sizeCard.dataset.step = categories.length;
      totalSteps = categories.length + (sizeData ? 1 : 0);
      configuredTotal = Math.max(configuredTotal, totalSteps);
      if (observer) observer.observe(category, { childList: true, subtree: true, characterData: true });
      update();
    }

    function syncDynamicCategories() {
      for (var index = categories.length - 1; index >= 0; index -= 1) {
        if (categories[index].isConnected) continue;
        var removedCard = grid.querySelector('[data-step="' + index + '"]');
        if (removedCard) removedCard.remove();
        categories.splice(index, 1);
        touchedCategories.splice(index, 1);
        lastValues.splice(index, 1);
      }
      Array.prototype.forEach.call(panel.querySelectorAll('.cpb-category'), addDynamicCategory);
      categories.forEach(function (category, index) {
        var card = grid.querySelector('[data-step="' + category.dataset.vvStep + '"]');
        category.dataset.vvStep = index;
        if (card) card.dataset.step = index;
      });
      if (sizeCard) sizeCard.dataset.step = categories.length;
      totalSteps = categories.length + (sizeData ? 1 : 0);
      configuredTotal = totalSteps;
    }

    function addConfiguredPlaceholder(label) {
      var normalized = categoryKey(label);
      var alreadyRendered = categories.some(function (category) { return categoryKey(labelFor(category)) === normalized; });
      if (alreadyRendered || grid.querySelector('[data-category-label="' + normalized + '"]')) return;

      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'vv-wizard-card is-pending-category';
      card.dataset.categoryLabel = normalized;
      card.innerHTML = '<span class="vv-wizard-card-icon">' + icon(label) + '</span><span class="vv-wizard-card-copy"><strong>' + displayLabel(label) + '</strong><small>Primero elige materiales</small></span><span class="vv-wizard-card-state" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg></span>';
      grid.insertBefore(card, sizeCard || null);
    }

    function loadConfiguredCategories() {
      var configUrl = root.dataset.cpbConfigUrl;
      if (!configUrl || panel.dataset.vvConfiguredCategoriesLoaded === 'true') return;
      panel.dataset.vvConfiguredCategoriesLoaded = 'true';
      fetch(configUrl).then(function (response) { return response.json(); }).then(function (config) {
        var panels = config && config.data && config.data.panels ? config.data.panels : [];
        var titles = [];
        var titleKeys = [];
        var idToKey = {};
        panels.forEach(function (configuredPanel) {
          (configuredPanel.categories || []).forEach(function (category) {
            idToKey[category.id] = category.title ? categoryKey(category.title) : '';
          });
        });
        panels.forEach(function (configuredPanel) {
          (configuredPanel.categories || []).forEach(function (category) {
            var key = category.title ? categoryKey(category.title) : '';
            if (key && titleKeys.indexOf(key) === -1) {
              titleKeys.push(key);
              titles.push(category.title);
            }
            (category.options || []).some(function (option) {
              var rules = (option.logic && option.logic.rules) || [];
              return rules.some(function (rule) {
                var depKey = rule.category ? idToKey[rule.category] : '';
                if (!depKey || depKey === key) return false;
                exoticDependencies[key] = depKey;
                return true;
              });
            });
          });
        });
        configuredTotal = Math.max(configuredTotal, titles.length + (sizeData ? 1 : 0));
        titles.forEach(addConfiguredPlaceholder);
        update();
      }).catch(function () {
        panel.dataset.vvConfiguredCategoriesLoaded = 'false';
      });
    }

    function removeDuplicateCards() {
      var rendered = {};
      Array.prototype.forEach.call(grid.querySelectorAll('.vv-wizard-card'), function (card) {
        var title = card.querySelector('strong');
        var key = title ? categoryKey(title.textContent) : '';
        if (!key) return;
        if (rendered[key]) {
          if (rendered[key].classList.contains('is-pending-category') && !card.classList.contains('is-pending-category')) {
            rendered[key].remove();
            rendered[key] = card;
          } else {
            card.remove();
          }
          return;
        }
        rendered[key] = card;
      });
      configuredTotal = grid.querySelectorAll('.vv-wizard-card').length;
    }

    function update() {
      if (reeditMode) {
        categories.forEach(function (category, index) {
          if (!touchedCategories[index] && valueFor(category)) touchedCategories[index] = true;
        });
      }
      var dependencyChosen = categories.some(function (category, index) {
        var key = categoryKey(labelFor(category));
        return (key === 'chinela' || key === 'tubo') && touchedCategories[index];
      });
      if (dependencyChosen) {
        Array.prototype.forEach.call(grid.querySelectorAll('.is-pending-category'), function (card) { card.remove(); });
      }
      removeDuplicateCards();
      var completed = 0;
      categories.forEach(function (category, index) {
        var key = categoryKey(labelFor(category));
        var depKey = exoticDependencies[key];
        var blockedByExotic = Boolean(depKey) && materialIsExotic(depKey);
        var unavailable = blockedByExotic || categoryHasNoOptions(category) || unavailableCategories[key];
        var value = touchedCategories[index] ? valueFor(category) : '';
        var card = grid.querySelector('[data-step="' + index + '"]');
        if (!card) return;
        card.hidden = unavailable;
        card.setAttribute('aria-hidden', unavailable ? 'true' : 'false');
        if (unavailable) return;
        var small = card.querySelector('small');
        card.classList.toggle('is-complete', Boolean(value));
        small.textContent = value || 'No has elegido';
        if (value) completed += 1;
      });
      if (sizeData) {
        var sizeCard = grid.querySelector('.vv-wizard-size-card');
        sizeCard.classList.toggle('is-complete', Boolean(selectedSize));
        sizeCard.querySelector('small').textContent = selectedSize || 'Elegir talla';
        if (selectedSize) completed += 1;
      }
      configuredTotal = grid.querySelectorAll('.vv-wizard-card:not([hidden])').length;
      var isComplete = configuredTotal > 0 && completed === configuredTotal;
      panel.classList.toggle('vv-wizard-complete', isComplete);
      shell.querySelector('.vv-wizard-cart').disabled = !isComplete;
      shell.querySelector('.vv-wizard-count').textContent = completed + ' de ' + configuredTotal + ' listos';
      syncTotalPrice();

      if (activeCategoryHasNoOptions()) {
        var pendingIndex = activeIndex;
        var pendingKey = categoryKey(labelFor(categories[pendingIndex]));
        window.setTimeout(function () {
          if (activeIndex === pendingIndex && activeCategoryHasNoOptions()) {
            unavailableCategories[pendingKey] = true;
            showOverview();
          }
        }, 250);
      }
    }

    function showOverview() {
      syncDynamicCategories();
      activeIndex = -1;
      panel.classList.add('vv-wizard-overview');
      shell.querySelector('.vv-wizard-overview-screen').hidden = false;
      shell.querySelector('.vv-wizard-detail-screen').hidden = true;
      categories.forEach(function (category) { category.classList.remove('vv-active-category'); });
      nav.hidden = true;
      update();
    }

    function showStep(index, focusControl) {
      if (index < 0 || index >= totalSteps) return showOverview();
      var targetKey = index < categories.length ? categoryKey(labelFor(categories[index])) : '';
      var targetDepKey = exoticDependencies[targetKey];
      var targetBlockedByExotic = Boolean(targetDepKey) && materialIsExotic(targetDepKey);
      if (index < categories.length && (targetBlockedByExotic || categoryHasNoOptions(categories[index]) || unavailableCategories[targetKey])) {
        var direction = activeIndex > index ? -1 : 1;
        var nextIndex = index + direction;
        while (nextIndex >= 0 && nextIndex < categories.length && categoryHasNoOptions(categories[nextIndex])) nextIndex += direction;
        if (nextIndex < 0 || nextIndex >= totalSteps) return showOverview();
        return showStep(nextIndex, focusControl);
      }
      activeIndex = index;
      panel.classList.remove('vv-wizard-overview');
      shell.querySelector('.vv-wizard-overview-screen').hidden = true;
      shell.querySelector('.vv-wizard-detail-screen').hidden = false;
      shell.querySelector('.vv-wizard-step-number').textContent = String(index + 1).padStart(2, '0');
      var isSizeStep = sizeData && index === categories.length;
      shell.querySelector('.vv-wizard-step-title').textContent = isSizeStep ? (sizeData.optionName || 'Talla') : displayLabel(labelFor(categories[index]));
      nav.querySelector('.vv-wizard-prev').disabled = index === 0;
      nav.querySelector('.vv-wizard-next').textContent = index === totalSteps - 1 ? 'Ver resumen' : 'Siguiente';
      if (index !== totalSteps - 1) nav.querySelector('.vv-wizard-next').insertAdjacentHTML('beforeend', '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m9 18 6-6-6-6"/></svg>');
      categories.forEach(function (category, categoryIndex) {
        category.classList.toggle('vv-active-category', !isSizeStep && categoryIndex === index);
      });
      slot.hidden = true;
      sizeOptions.hidden = !isSizeStep;
      nav.hidden = false;
      update();
      if (focusControl) {
        window.setTimeout(function () {
          var control = isSizeStep ? sizeOptions.querySelector('button') : categories[index].querySelector('input, button, [tabindex="0"]');
          if (control) control.focus({ preventScroll: true });
        }, 80);
      }
    }

    grid.addEventListener('click', function (event) {
      var card = event.target.closest('.vv-wizard-card');
      if (!card) return;
      if (card.classList.contains('is-pending-category')) {
        var targetKey = card.dataset.categoryLabel;
        syncDynamicCategories();
        var targetIndex = categories.findIndex(function (category) { return categoryKey(labelFor(category)) === targetKey; });
        if (targetIndex > -1) {
          showStep(targetIndex, true);
        } else {
          var message = card.querySelector('small');
          if (message) message.textContent = 'Primero elige Chinela y Tubo';
        }
        return;
      }
      showStep(Number(card.dataset.step), true);
    });
    function acceptActiveStep() {
      if (activeIndex < 0 || activeIndex >= categories.length) return;
      if (valueFor(categories[activeIndex])) touchedCategories[activeIndex] = true;
      update();
    }

    shell.querySelector('.vv-wizard-back').addEventListener('click', function () {
      acceptActiveStep();
      showOverview();
    });
    nav.querySelector('.vv-wizard-prev').addEventListener('click', function () {
      acceptActiveStep();
      showStep(activeIndex - 1, true);
    });
    nav.querySelector('.vv-wizard-summary').addEventListener('click', function () {
      acceptActiveStep();
      showOverview();
    });
    nav.querySelector('.vv-wizard-next').addEventListener('click', function () {
      acceptActiveStep();
      showStep(activeIndex + 1, true);
    });
    shell.querySelector('.vv-wizard-cart').addEventListener('click', function () {
      var nativeCartButton = panel.closest('.cpb-panels-container').querySelector('.cpb-add-to-cart-button, .cpb-add-to-cart');
      if (nativeCartButton) nativeCartButton.click();
    });

    panel.addEventListener('click', function (event) {
      if (activeIndex < 0 || activeIndex >= categories.length) return;
      var explicitOption = event.target.closest('[role="option"], .cpb-option-type-img, .cpb-option-type-text, .cpb-option-type-color, .cpb-swatch');
      if (!explicitOption) return;
      var selectedIndex = activeIndex;
      window.setTimeout(function () {
        touchedCategories[selectedIndex] = true;
        update();
      }, 500);
    }, true);

    sizeOptions.addEventListener('click', function (event) {
      var button = event.target.closest('.vv-wizard-size-button');
      if (!button) return;
      selectedSize = button.dataset.size;
      window.vvCpbSelectedSize = selectedSize;
      window.vvCpbSelectedVariantId = button.dataset.variantId;
      Array.prototype.forEach.call(sizeOptions.querySelectorAll('button'), function (item) {
        item.classList.toggle('is-selected', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      shell.querySelector('.vv-wizard-size-error').hidden = true;
      update();
    });

    panel.closest('.cpb-panels-container').addEventListener('click', function (event) {
      if (!sizeData || selectedSize || !event.target.closest('.cpb-add-to-cart-button')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      shell.querySelector('.vv-wizard-size-error').hidden = false;
      showStep(categories.length, true);
    }, true);

    var observer = new MutationObserver(function () {
      var currentValues = categories.map(valueFor);
      var selectedNewValue = activeIndex >= 0 && activeIndex < categories.length && currentValues[activeIndex] && currentValues[activeIndex] !== lastValues[activeIndex];
      if (selectedNewValue) {
        touchedCategories[activeIndex] = true;
        var changedKey = categoryKey(labelFor(categories[activeIndex]));
        if (changedKey === 'chinela' || changedKey === 'tubo') unavailableCategories = {};
      }
      update();
      lastValues = currentValues;
    });
    categories.forEach(function (category) { observer.observe(category, { childList: true, subtree: true, characterData: true }); });
    new MutationObserver(syncTotalPrice).observe(root, { childList: true, subtree: true, characterData: true });
    new MutationObserver(syncDynamicCategories).observe(panel, { childList: true, subtree: true });
    syncDynamicCategories();
    loadConfiguredCategories();
    update();

    function isBlocked(index) {
      var card = grid.querySelector('[data-step="' + index + '"]');
      return !card || card.hidden;
    }

    panel.vvApi = { categories: categories, showStep: showStep, isBlocked: isBlocked };
    return panel.vvApi;
  }

  function setupPreviewHotspots(categories, showStep, isBlocked) {
    var previewRoot = root.querySelector('.cpb-preview-container');
    if (!previewRoot || previewRoot.dataset.vvHotspotsReady === 'true') return;
    previewRoot.dataset.vvHotspotsReady = 'true';

    var highlight = document.createElement('canvas');
    highlight.className = 'vv-preview-highlight';
    highlight.style.cssText = 'position:absolute;pointer-events:none;z-index:60;';

    /* Anchor the overlay inside the same Konva stage as the boot layers and copy
       the source canvas's own box. Positioning it from a getBoundingClientRect
       snapshot (as before) drifted the moment the sticky preview scrolled; as a
       sibling of the layers it shares their coordinate space, so the white mask
       stays pixel-aligned to the PNG through any scroll or rescale. */
    function ensureHighlightOver(sourceCanvas) {
      var stage = sourceCanvas.parentElement;
      if (highlight.parentElement !== stage) stage.appendChild(highlight);
      var cs = getComputedStyle(sourceCanvas);
      highlight.style.top = cs.top === 'auto' ? '0px' : cs.top;
      highlight.style.left = cs.left === 'auto' ? '0px' : cs.left;
      highlight.style.width = cs.width;
      highlight.style.height = cs.height;
      if (highlight.width !== sourceCanvas.width) highlight.width = sourceCanvas.width;
      if (highlight.height !== sourceCanvas.height) highlight.height = sourceCanvas.height;
    }

    function paintHighlight(sourceCanvas) {
      ensureHighlightOver(sourceCanvas);
      var ctx = highlight.getContext('2d');
      ctx.clearRect(0, 0, highlight.width, highlight.height);
      ctx.drawImage(sourceCanvas, 0, 0);
      ctx.globalCompositeOperation = 'source-in';
      ctx.fillStyle = 'rgba(255, 255, 255, 0.45)';
      ctx.fillRect(0, 0, highlight.width, highlight.height);
      ctx.globalCompositeOperation = 'source-over';
    }

    function clearHighlight() {
      if (highlight.width) highlight.getContext('2d').clearRect(0, 0, highlight.width, highlight.height);
    }

    function categoryIndexForId(categoryId) {
      for (var i = 0; i < categories.length; i += 1) {
        if (categories[i].dataset.categoryId === categoryId) return i;
      }
      return -1;
    }

    function layerAt(clientX, clientY) {
      var canvases = Array.prototype.slice.call(previewRoot.querySelectorAll('canvas:not(.vv-preview-highlight)'));
      for (var i = canvases.length - 1; i >= 0; i -= 1) {
        var canvas = canvases[i];
        var categoryId = canvas.dataset.category;
        if (!categoryId || categoryId === 'base') continue;
        var index = categoryIndexForId(categoryId);
        if (index > -1 && isBlocked(index)) continue;
        var rect = canvas.getBoundingClientRect();
        if (!rect.width || !rect.height || clientX < rect.left || clientX >= rect.right || clientY < rect.top || clientY >= rect.bottom) continue;
        var x = Math.floor((clientX - rect.left) * (canvas.width / rect.width));
        var y = Math.floor((clientY - rect.top) * (canvas.height / rect.height));
        var pixel;
        try {
          pixel = canvas.getContext('2d').getImageData(x, y, 1, 1).data;
        } catch (error) {
          continue;
        }
        if (pixel[3] > 10) return { canvas: canvas, categoryId: categoryId };
      }
      return null;
    }

    function inOverview() {
      var detail = root.querySelector('.vv-wizard-detail-screen');
      return !detail || detail.hidden;
    }

    var currentCategoryId = null;
    previewRoot.addEventListener('mousemove', function (event) {
      if (!inOverview()) {
        if (currentCategoryId !== null) {
          clearHighlight();
          currentCategoryId = null;
        }
        previewRoot.style.cursor = '';
        return;
      }
      var hit = layerAt(event.clientX, event.clientY);
      var index = hit ? categoryIndexForId(hit.categoryId) : -1;
      if (!hit || index === -1) {
        if (currentCategoryId !== null) {
          clearHighlight();
          currentCategoryId = null;
        }
        previewRoot.style.cursor = '';
        return;
      }
      previewRoot.style.cursor = 'pointer';
      if (hit.categoryId !== currentCategoryId) {
        currentCategoryId = hit.categoryId;
        paintHighlight(hit.canvas);
      }
    });

    previewRoot.addEventListener('mouseleave', function () {
      clearHighlight();
      currentCategoryId = null;
      previewRoot.style.cursor = '';
    });

    previewRoot.addEventListener('click', function (event) {
      if (!inOverview()) return;
      var hit = layerAt(event.clientX, event.clientY);
      clearHighlight();
      currentCategoryId = null;
      if (!hit) return;
      var index = categoryIndexForId(hit.categoryId);
      if (index > -1) showStep(index, true);
    });

    /* The overlay lives inside the Konva stage, so a CPB re-render (picking a
       material) leaves the last painted mask sitting on top of the freshly drawn
       layer -- the part reads as solid white until the pointer moves again. Wipe
       it whenever the stage repaints so the white only ever exists under the
       cursor. */
    new MutationObserver(function () {
      if (currentCategoryId === null) return;
      clearHighlight();
      currentCategoryId = null;
    }).observe(previewRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['width', 'height', 'style'] });
  }

  function boot() {
    cleanTemplateTokens(root);
    Array.prototype.forEach.call(document.querySelectorAll('#product-builder .cpb-quantity-value'), function (input) {
      if (String(input.value) !== '1') {
        input.value = 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var quantity = input.closest('.cpb-quantity') || input.parentElement;
      if (quantity) quantity.style.setProperty('display', 'none', 'important');
    });
    var panels = document.querySelectorAll('#product-builder .cpb-product-panel');
    Array.prototype.forEach.call(panels, function (panelEl) {
      var api = setup(panelEl);
      if (api) setupPreviewHotspots(api.categories, api.showStep, api.isBlocked);
    });
  }

  var root = document.getElementById('product-builder');
  if (!root) return;
  installCartProperty();
  new MutationObserver(boot).observe(root, { childList: true, subtree: true });
  boot();
}());
